import React from "react";
import {
  Table,
  Spin,
  DatePicker,
  Row,
  Col,
  Button,
  Input,
  Icon,
  Empty,
  Layout,
  Form,
} from "antd";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { ReportService } from "../../services/reports/reportService";
import { handleError } from "../../utils/ErrorHandlers";
import Page from "../general/Page";
// import CDRSwitchedCalls from "./CDRSwitchedCalls";
import Highlighter from "react-highlight-words";
// import "./CDRTable.css";
import AudioPlayer from "../streaming/AudioPlayer";
import { ro } from "date-fns/locale";
import { convertTZToLocal } from "../general/DateTzHelper";

import { Translation } from "react-i18next";
import i18next from "i18next";
import { Excel } from "antd-table-saveas-excel";

const { RangePicker } = DatePicker;

class AgentChangeState extends React.Component {
  constructor(props) {
    super(props);
    this.props.context.setCurrentComponent("agentChangeStatusReport");
    // this.cdrService = new CdrService();
    this.reportService = new ReportService();
    this.state = {
      searchText: "",
      isFetching: false,
      visible: false,
      data: [],
      file: null,
      url: "h",
      audio: null,
      play: false,
      searchedColumn: "",
    };
  }

  componentDidMount() {
    this.props.context.user.userType == "AGENT"
      ? this.getChangeStatusForAgent()
      : this.getChangeStatusForAccount();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.location.key !== this.props.location.key) {
      this.componentDidMount();
    }
  }
  async getChangeStatusForAgent() {
    try {
      this.setState({ isFetching: true });
      let data = await this.reportService.getAgentChangeStatusForAgent(
        this.props.context.session_id
      );
      this.setState({
        data: this.formatData(data),
        isFetching: false,
      });
    } catch (e) {
      this.setState({ isFetching: false });
      handleError(e);
    }
  }

  async getChangeStatusForAccount() {
    try {
      this.setState({ isFetching: true });
      let data = await this.reportService.getAgentChangeStatusForAccount(
        this.props.context.session_id
      );
      this.setState({
        data: this.formatData(data),
        isFetching: false,
      });
    } catch (e) {
      this.setState({ isFetching: false });
      handleError(e);
    }
  }

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={i18next.t(`Search ${dataIndex}`)}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => {
            this.setState({ searchedColumn: dataIndex });
            this.handleSearch(selectedKeys, confirm);
          }}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => {
            this.setState({ searchedColumn: dataIndex });

            this.handleSearch(selectedKeys, confirm);
          }}
          icon="search"
          size="small"
          style={
            this.props.context.curr_dir === "ltr" &&
            this.props.context.curr_lang === "en"
              ? { width: 100, marginRight: 8 }
              : { width: 100, marginLeft: 8 }
          }
        >
          {i18next.t("Search")}
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 80 }}
        >
          {i18next.t("Reset")}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: "#d73a31" }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex] != null &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
  });

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };
  itemRender = (current, type, originalElement) => {
    if (type === "prev") {
      return (
        <a className="ant-pagination-item-link">
          <Icon
            type={this.props.context.curr_dir === "rtl" ? "right" : "left"}
          />
        </a>
      );
    }
    if (type === "next") {
      return (
        <a className="ant-pagination-item-link">
          <Icon
            type={this.props.context.curr_dir === "rtl" ? "left" : "right"}
          />
        </a>
      );
    }
    return originalElement;
  };

  formatData(data) {
    const updated_data = [];
    if (data.ivrList === null) {
      return [];
    }

    for (var i = 0; i < data.ivrList.length; i++) {
      var row = {};
      row["key"] = i + 1;
      row["agent_name"] = data.ivrList[i]["agentId"];
      row["from_state"] = i18next.t(data.ivrList[i]["fromState"]);
      row["to_state"] = i18next.t(data.ivrList[i]["toState"]);
      row["changed_at"] = convertTZToLocal(data.ivrList[i]["changedAt"]);
      row["changed_by"] = data.ivrList[i]["changedBy"];
      updated_data.push(row);
    }

    return updated_data;
  }

  render() {
    const columns = [
      {
        title: i18next.t("Agent Name"),
        dataIndex: "agent_name",
        key: "agent_name",
        ...this.getColumnSearchProps("agent_name"),
        render: (text) =>
          this.state.searchedColumn === "agent_name" ? (
            <Highlighter
              highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={text}
            />
          ) : (
            text
          ),
      },
      {
        title: i18next.t("From State"),
        dataIndex: "from_state",
        key: "from_state",
        ...this.getColumnSearchProps("from_state"),
        render: (text) =>
          this.state.searchedColumn === "from_state" ? (
            <Highlighter
              highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={text}
            />
          ) : (
            text
          ),
      },
      {
        title: i18next.t("To State"),
        dataIndex: "to_state",
        key: "to_state",
        ...this.getColumnSearchProps("to_state"),
        render: (text) =>
          this.state.searchedColumn === "to_state" ? (
            <Highlighter
              highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={text}
            />
          ) : (
            text
          ),
      },
      {
        title: i18next.t("Changed At"),
        dataIndex: "changed_at",
        key: "changed_at",

        sorter: (a, b) =>
          new Date(a.changed_at).getTime() - new Date(b.changed_at).getTime(),
      },
      {
        title: i18next.t("Changed By"),
        dataIndex: "changed_by",
        key: "changed_by",
        ...this.getColumnSearchProps("changed_by"),
        render: (text) =>
          this.state.searchedColumn === "changed_by" ? (
            <Highlighter
              highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={text}
            />
          ) : (
            text
          ),
      },
    ];

    let { isFetching } = this.state;
    const { Header, Footer, Content } = Layout;

    return (
      <Translation>
        {(t) => (
          <Page title={t("Agent Change State Report")}>
            <Form.Item
              wrapperCol={{
                xs: { span: 24, offset: 0 },
                sm: { span: 16, offset: 8 },
              }}
            >
              {" "}
              <Button
                type="primary"
                onClick={() => {
                  const excelColumns = [
                    { title: i18next.t("Agent Name"), dataIndex: "agent_name" },
                    { title: i18next.t("From State"), dataIndex: "from_state" },
                    { title: i18next.t("To State"), dataIndex: "to_state" },
                    { title: i18next.t("Changed At"), dataIndex: "changed_at" },
                    { title: i18next.t("Changed By"), dataIndex: "changed_by" },
                  ];
                  const excel = new Excel();
                  excel
                    .addSheet("test")
                    .addColumns(excelColumns)
                    .addDataSource(this.state.data)
                    .saveAs("Agent_Change_State_Report.xlsx");
                }}
                className="button-submit"
              >
                {t("Export")}
                <Icon type="download" />
              </Button>
            </Form.Item>
            {isFetching ? (
              <Spin></Spin>
            ) : (
              <div>
                <Table
                  columns={columns}
                  bodyStyle={{
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                    borderRadius: "8px",
                    marginBottom: "25px",
                  }}
                  dataSource={this.state.data}
                  pagination={{
                    position: "bottom",
                    pageSize: 10,
                    itemRender: this.itemRender,
                  }}
                  bordered
                  locale={{
                    emptyText: (
                      <Empty
                        description={i18next.t("Empty")}
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                      />
                    ),
                  }}
                />
              </div>
            )}
          </Page>
        )}
      </Translation>
    );
  }
}

export default withSharedStateConsumer(AgentChangeState);
